import * as React from 'react';
export const pulseSvg = React.forwardRef(function pulseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#231F20',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.532 15.503h4.071v-.001c.997 0 1.929-.824 2.06-1.82l.182-1.211c.226-1.215-.569-1.955-1.566-1.955h-4l-.747 4.987Zm-.734 4.9L11.963 26C11.909 25.981 7 26 7 26L9.985 6h9.61c3.273 0 5.574 2.64 5.14 5.914l-.373 2.506c-.434 3.273-3.491 5.982-6.764 5.982h-4.8Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm13.829 26 .525-3.677h8.182l-.306 2.145C22.065 25.51 21.53 26 20.69 26h-6.861Z',
      fill: '#EE7623',
    }),
  );
});
pulseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pulse = {
  category: 'brand',
  colorable: false,
  name: 'pulse',
  svg: pulseSvg,
};
